<template>
  <BaseDialog v-model="showDialog" :subtitle="subtitle" removeFullscreen>
    <div>
      <v-btn class="mb-4" color="primary" block :to="{ name: 'RUH', query }">
        Ny HMS hendelse
      </v-btn>
      <v-btn color="primary" block :to="{ name: 'RO', query }">
        Ny HMS observasjon
      </v-btn>
    </div>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String,
      default: "mdi-home",
    },
    users: {
      type: Array,
    },
    projectId: {
      type: [Number || null],
    },
    query: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
